import React from 'react';
import { motion } from 'framer-motion';
import { X, CheckCircle2 } from 'lucide-react';
export function ParadigmaSection() {
  const myths = ['No necesitás más herramientas', 'No necesitás funnels complicados', 'No necesitás gastar en anuncios'];
  return <section className="py-24 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-111">
      <div className="max-w-4xl mx-auto" data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.3
      }} className="text-center mb-16" data-id="element-113">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-brand-black mb-6 leading-tight" data-id="element-114">
            No necesitás más herramientas.
            <br data-id="element-115" />
            <span className="text-brand-orange" data-id="element-116">Necesitás un sistema.</span>
          </h2>
        </motion.div>

        <div className="bg-gray-50 rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100 mb-12" data-id="element-117">
          <div className="space-y-6 mb-10" data-id="element-118">
            {myths.map((myth, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -15
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: index * 0.08
          }} className="flex items-center gap-4 text-gray-400" data-id="element-119">
                <X className="w-6 h-6 shrink-0 text-red-400" data-id="element-120" />
                <p className="text-xl md:text-2xl font-medium line-through decoration-red-400/50 decoration-2" data-id="element-121">
                  {myth}
                </p>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: 0.15
        }} className="bg-brand-black text-white rounded-2xl p-6 md:p-8 flex items-start md:items-center gap-4 shadow-xl" data-id="element-122">
            <CheckCircle2 className="w-8 h-8 md:w-10 md:h-10 text-brand-orange shrink-0 mt-1 md:mt-0" data-id="element-123" />
            <p className="text-xl md:text-3xl font-heading font-bold" data-id="element-124">
              Lo que te falta es un sistema simple y ejecutable
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        delay: 0.2
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-125">
          <a href="#" className="w-full sm:w-auto bg-brand-orange text-brand-black font-bold text-lg px-10 py-4 rounded-xl shadow-lg hover:scale-[1.03] transition-transform text-center" data-id="element-126">
            Quiero el sistema
          </a>
          <a href="https://wa.me/5491100000000" className="w-full sm:w-auto text-brand-black font-medium hover:text-brand-orange transition-colors text-center underline underline-offset-4" data-id="element-127">
            Hablar por WhatsApp
          </a>
        </motion.div>
      </div>
    </section>;
}